import { Button } from '@app/app/_components/Button/Button';
import { Heading } from '@app/app/_components/Heading/Heading';
import { Modal } from '@app/app/_components/Modal/Modal';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { ArrowRightIcon } from '@app/app/_icons/ArrowRightIcon';
import { CloseIcon } from '@app/app/_icons/CloseIcon';
import { ExclamationCircleIcon } from '@app/app/_icons/ExclamationCircleIcon';
import { useTranslations } from 'next-intl';

interface Props {
    updateModalOpen: boolean;
    handleCloseUpdateModal: () => void;
    navigateToStep: () => void;
}

export function UpdateModal({ updateModalOpen, handleCloseUpdateModal, navigateToStep }: Props) {
    const t = useTranslations();

    return (
        <Modal
            open={updateModalOpen}
            className="mt-auto md:mt-[15vh]"
            cardClassName="gap-8 p-8 text-center"
            onClose={handleCloseUpdateModal}>
            <div className="mx-auto">
                <ExclamationCircleIcon className="size-18 text-orange-500" />
            </div>

            <div className="flex flex-col gap-2">
                <Heading level="h2">{t('eshop.transport.areYouSureYouWantToProceed')}</Heading>
                <Paragraph>{t('eshop.transport.toUpdateThisSectionExplanation')}</Paragraph>
            </div>

            <div className="flex flex-col gap-6 md:flex-row">
                <Button
                    className="grow"
                    onClick={handleCloseUpdateModal}
                    variant="outlined"
                    rightAddon={<CloseIcon className="size-4" />}>
                    {t('general.cancel')}
                </Button>

                <Button className="grow" onClick={navigateToStep} rightAddon={<ArrowRightIcon className="size-4" />}>
                    {t('general.proceed')}
                </Button>
            </div>
        </Modal>
    );
}
